import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isLoggedIn: boolean;
  currentUser: {
    email: string;
    name: string;
    favorites: string[];
  } | null;
}

const initialState: AuthState = {
  isLoggedIn: false,
  currentUser: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signUp: (
      state,
      action: PayloadAction<{ email: string; name: string; password: string }>
    ) => {
      const { email, name, password } = action.payload;
      const userData = { email, name, password, favorites: [] };
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.removeItem("loggedOut");
      state.isLoggedIn = true;
      state.currentUser = { email, name, favorites: [] };
    },
    login: (
      state,
      action: PayloadAction<{
        email: string;
        name: string;
        favorites: string[];
      }>
    ) => {
      state.isLoggedIn = true;
      state.currentUser = action.payload;
      localStorage.removeItem("loggedOut");
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.currentUser = null;
      localStorage.setItem("loggedOut", "true");
    },
    checkUserFromStorage: (state) => {
      const loggedOut = localStorage.getItem("loggedOut");
      if (loggedOut !== "true") {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          state.isLoggedIn = true;
          state.currentUser = {
            email: userData.email,
            name: userData.name,
            favorites: userData.favorites || [],
          };
        }
      }
    },
    addToFavorites: (state, action: PayloadAction<string>) => {
      if (state.currentUser) {
        state.currentUser.favorites.push(action.payload);
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...state.currentUser,
            favorites: state.currentUser.favorites,
          })
        );
      }
    },
    removeFromFavorites: (state, action: PayloadAction<string>) => {
      if (state.currentUser) {
        state.currentUser.favorites = state.currentUser.favorites.filter(
          (id) => id !== action.payload
        );
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...state.currentUser,
            favorites: state.currentUser.favorites,
          })
        );
      }
    },
  },
});

export const {
  signUp,
  login,
  logout,
  checkUserFromStorage,
  addToFavorites,
  removeFromFavorites,
} = authSlice.actions;
export default authSlice.reducer;
